module.exports = __webpack_public_path__ + "img/full.4aa57ab1.png";